<template lang="html">

  <section class="header" id="header">

    <div class="menu" @mouseleave="select = ''">

      <div class="supertop">
        <router-link class="menu-el char-split telefono-atc" :to="'/' + $i18n.locale + '/' + $t('enlaces.contacto')"> 
          <img src="/static/img/telefono-atc.png">
          <figure>{{ $t('header.contacto') }}</figure>
        </router-link>
      </div>

      <div class="top row-end" :with-color="color">
        <router-link to="/" class="logo-header" :small="!!$route.meta.familia">
          <img src="/static/img/logo.png" alt="Logo Risi" width="120">
        </router-link>

        <nav class="menu-productos row-end">
          <!-- <router-link class="menu-el char-split" data-splitting="chars" :to="'/'+$i18n.locale+'/'+$t('enlaces.patatas')">{{$t('header.patatas')}}
          </router-link> -->
          <router-link class="menu-el char-split" :to="'/' + $i18n.locale + '/' + $t('enlaces.snacks')" @mouseover.native="setSubmenu('snacks')">{{ $t('header.snack') }}
          </router-link>
          <router-link class="menu-el char-split" :to="'/'+$i18n.locale+'/'+$t('enlaces.patatas')">{{$t('header.patatas')}}
          </router-link>
          <router-link class="menu-el char-split" :to="'/'+$i18n.locale+'/'+$t('enlaces.galletas')">{{$t('header.galletas')}}
          </router-link>
          <router-link class="menu-el char-split" :to="'/'+$i18n.locale+'/'+$t('enlaces.caramelos')">{{$t('header.caramelos')}}
          </router-link>
          <router-link class="menu-el char-split" :to="'/'+$i18n.locale+'/'+$t('enlaces.borges')">{{$t('header.frutosSecos')}}
          </router-link>
          <router-link class="menu-el char-split telefono-atc" :to="'/' + $i18n.locale + '/' + $t('enlaces.contacto')"> 
            <img src="/static/img/telefono-atc.png">
            <figure>{{ $t('header.contacto') }}</figure>
          </router-link>
        </nav>

        <a class="hamburguer" @click="showMenu = !showMenu" :show="showMenu">
          <span class="line-top"></span>
          <span class="line-bottom"></span>
          <span class="cross-left"></span>
          <span class="cross-right"></span>
        </a>
        <lang-selector></lang-selector>
      </div>
      <div class="bottom" v-if="!!$route.meta.familia" :scroll="($route.meta.familia != 'snacks' && $route.meta.familia != 'patatas')">

        <div class="-snacks row-center" v-show="$route.meta.familia == 'snacks'">

          <slick ref="slick" :options="slickOptions">

            <div class="slide">
              <router-link class="menu-el -snack" :to="'/'+$i18n.locale+'/'+$t('enlaces.gusanitos')">
                <img src="/static/img/logos/gusanitos-w.png" class="white" alt="logo-header-gusanitos-w">
                <img src="/static/img/logos/gusanitos.png" class="color" alt="logo-header-gusanitos">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack" :to="'/'+$i18n.locale+'/'+$t('enlaces.palomitas')">
                <img src="/static/img/logos/palomitas-w.png" class="white" alt="logo-header-palomitas-w">
                <img src="/static/img/logos/palomitas.png" class="color" alt="logo-header-palomitas">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack" :to="'/'+$i18n.locale+'/'+$t('enlaces.risketos')">
                <img src="/static/img/logos/risketos-w.png" class="white" alt="logo-header-risketos-w">
                <img src="/static/img/logos/risketos.png" class="color" alt="logo-header-risketos">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack" :to="'/'+$i18n.locale+'/'+$t('enlaces.mios')">
                <img src="/static/img/logos/mios-w.png" class="white" alt="logo-header-mios-w">
                <img src="/static/img/logos/mios-b.png" class="color" alt="logo-header-mios-b">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack" :to="'/'+$i18n.locale+'/'+$t('enlaces.triskys')">
                <img src="/static/img/logos/triskys-w.png" class="white" alt="logo-header-triskys-w">
                <img src="/static/img/logos/triskys.png" class="color" alt="logo-header-triskys">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack" :to="'/'+$i18n.locale+'/'+$t('enlaces.matchBall')">
                <img src="/static/img/logos/match-ball-w.png" class="white" alt="logo-header-match-ball-w">
                <img src="/static/img/logos/match-ball.png" class="color" alt="logo-header-match-ball">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack" :to="'/' + $i18n.locale + '/' + $t('enlaces.jummy')">
                <img src="/static/img/logos/jummy-w.png" class="white" alt="logo-header-match-ball-w">
                <img src="/static/img/logos/jummy.png" class="color" alt="logo-header-match-ball">
              </router-link>
            </div>
            <!-- <div class="slide">
              <router-link class="menu-el -snack" :to="$t('enlaces.snacks')+'/patatas'">
                <img src="/static/img/logos/logo-patatas-w.png" class="white" alt="logo-header-logo-patatas-w">
                <img src="/static/img/logos/logo-patatas.png" class="color" alt="logo-header-logo-patatas">
              </router-link>
            </div>-->
            <div class="slide">
              <router-link class="menu-el -snack -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.surtis4u')">
                <img src="/static/img/logos/surtido-w.png" class="white" alt="logo-header-logo-surtis4u-w">
                <img src="/static/img/logos/surtido.png" class="color" alt="logo-header-logo-surtis4u">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.tejitas')">
                <img src="/static/img/logos/tejitas-w.png" class="white" alt="logo-header-logo-tejitas-w">
                <img src="/static/img/logos/tejitas.png" class="color" alt="logo-header-logo-tejitas">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.buscalios')">
                <img src="/static/img/logos/buscalios-w.png" class="white" alt="logo-header-logo-buscalios-w">
                <img src="/static/img/logos/buscalios.png" class="color" alt="logo-header-logo-buscalios">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.pajitas')">
                <img src="/static/img/logos/pajitas-w.png" class="white" alt="logo-header-logo-pajitas-w">
                <img src="/static/img/logos/pajitas.png" class="color" alt="logo-header-logo-pajitas">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.trikers')">
                <img src="/static/img/logos/trikers-w.png" class="white" alt="logo-header-logo-trikers-w">
                <img src="/static/img/logos/trikers.png" class="color" alt="logo-header-logo-trikers">
              </router-link>
            </div>
          </slick>
        </div>

        <div class="-snacks row-center" v-show="$route.meta.familia == 'patatas'">

          <slick ref="slick" :options="slickOptionsPatatas">

            <div class="slide">
              <router-link class="menu-el -snack -big" :to="'/'+$i18n.locale+'/'+$t('enlaces.originales')">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/submenu/originales-blanco.svg'" class="white" alt="logo-header-palomitas-w">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/submenu/originales.svg'" class="color" alt="logo-header-palomitas">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -big" :to="'/'+$i18n.locale+'/'+$t('enlaces.onduladas')">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/submenu/onduladas-blanco.svg'" class="white" alt="logo-header-risketos-w">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/submenu/onduladas.svg'" class="color" alt="logo-header-risketos">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -big" :to="'/'+$i18n.locale+'/'+$t('enlaces.selectas')">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/submenu/selectas-blanco.svg'" class="white" alt="logo-header-mios-w">
                <img :src="'/static/img/patatas/'+$i18n.locale+'/submenu/selectas.png'" class="color" alt="logo-header-mios-b">
              </router-link>
            </div>
            <div class="slide">
              <router-link class="menu-el -snack -big" :to="'/'+$i18n.locale+'/'+$t('enlaces.exportacion')">
                <img src="/static/img/logos/logo-patatas-exportacion.png" class="white" alt="logo-header-mios-w">
                <img src="/static/img/logos/logo-patatas-exportacion-w.png" class="color" alt="logo-header-mios-b"> 
              </router-link>
            </div>

          </slick>
        </div>


        <nav class="row-center ais -galletas" v-show="$route.meta.familia == 'galletas'">
          <router-link class="menu-el -galleta" :to="'/'+$i18n.locale+'/'+$t('enlaces.chocolate')">
            <img src="/static/img/logos/bsan-0.svg" class="white" alt="logo-header-chocolate-w">
            <img src="/static/img/logos/bsan-0-w.svg" class="color" alt="logo-header-chocolate">
          </router-link>
          <router-link class="menu-el -galleta" :to="'/'+$i18n.locale+'/'+$t('enlaces.adultas')">
            <img src="/static/img/logos/bsan-sin-gluten.svg" class="white" alt="logo-header-singluten-w">
            <img src="/static/img/logos/bsan-sin-gluten-w.svg" class="color sin-gluten" alt="logo-header-singluten">
          </router-link>

          <router-link class="menu-el -galleta" :to="'/'+$i18n.locale+'/'+$t('enlaces.plus')">
            <img src="/static/img/logos/bsan-plus-w.svg" class="white bsan-plus" alt="logo-header-plus-w">
            <img src="/static/img/logos/bsan-plus.svg" class="color" alt="logo-header-plus">
          </router-link>



          <router-link class="menu-el -galleta" :to="'/'+$i18n.locale+'/'+$t('enlaces.fabs')">
            <img src="/static/img/logos/fabs.png" class="white">
            <img src="/static/img/logos/logo-fabs-w.png" class="color">
          </router-link>
        </nav>

        <nav class="row-center ais -caramelos" v-show="$route.meta.familia == 'caramelos'">
          <router-link class="menu-el -caramelo -otros -azucares" :to="'/'+$i18n.locale+'/'+$t('enlaces.azucares0')">
            <img :src="'/static/img/sticker-sin-azucares-'+$i18n.locale+'.svg'" class="white">
            <img :src="'/static/img/sticker-sin-azucares-color-'+$i18n.locale+'.svg'" class="color">
          </router-link>
          <router-link class="menu-el -caramelo -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.caramelosTradicionales')">
            <h2 class="column-center">{{$t('header.caramelos')}}<br>{{$t('header.tradicionales')}}</span></h2>
          </router-link>
        </nav>


        <nav class="row-center ais -borges" v-show="$route.meta.familia == 'frutos-secos'">
          <router-link class="menu-el" :to="'/'+$i18n.locale+'/'+$t('enlaces.frutossecos')">
            <img :src="'/static/img/productos/frutos-secos/title-frutos-secos-'+$i18n.locale+'.png'" class="white">
            <img :src="'/static/img/productos/frutos-secos/title-frutos-secos-color-'+$i18n.locale+'.png'" class="color">
          </router-link>
          <router-link class="menu-el" :to="'/'+$i18n.locale+'/'+$t('enlaces.pipas')">
            <img :src="'/static/img/productos/frutos-secos/title-pipas-'+$i18n.locale+'.png'" class="white">
            <img :src="'/static/img/productos/frutos-secos/title-pipas-color-'+$i18n.locale+'.png'" class="color">
          </router-link>
        </nav>

      </div>

      <div class="bottom" :scroll="true" v-if="$route.meta.incodigoconducta">
        <nav class="row-center ais -cumplimiento">
          <router-link class="menu-el -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.cartapresidente')">
            <h2 class="column-center" v-html="$t('header.cartapresidente')"></h2>
          </router-link>
          <router-link class="menu-el -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.principiosgenerales')">
            <h2 class="column-center" v-html="$t('header.principiosgenerales')"></h2>
          </router-link>
          <router-link class="menu-el -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.risiempleados')">
            <h2 class="column-center" v-html="$t('header.risiempleados')"></h2>
          </router-link>
          <router-link class="menu-el -otros" :to="'/'+$i18n.locale+'/'+$t('enlaces.risiconsumidores')">
            <h2 class="column-center" v-html="$t('header.risiconsumidores')"></h2>
          </router-link>
          <router-link class="menu-el -otros" :to="'/' + $i18n.locale + '/' + $t('enlaces.risisociedad')">
            <h2 class="column-center" v-html="$t('header.risisociedad')"></h2>
          </router-link>
          <router-link class="menu-el -otros -large" :to="'/'+$i18n.locale+'/'+$t('enlaces.risiproveedores')">
            <h2 class="column-center" v-html="$t('header.risiproveedores')"></h2>
          </router-link>
          <router-link class="menu-el -otros -large" :to="'/'+$i18n.locale+'/'+$t('enlaces.cumplimientoetico')">
            <h2 class="column-center" v-html="$t('header.risicumplimiento')"></h2>
          </router-link>

        </nav>
      </div>

    </div>

    <div class="desplegable row-center" :show="showMenu">

      <nav class="enlaces">
        <div class="link-cont" @click="showMenu = false">
          <router-link class="link-el -inicio" to="/">{{$t('header.inicio')}}</router-link>
        </div>

        <div class="link-cont -sobrerisi" :show="showSobreRisi">
          <a class="link-el -sobrerisi" @click="showSobreRisi = true" @mouseover="showEspiral = true">{{$t('header.sobre_risi')}}</a>
          <div class="childrens" :show="showSobreRisi">
            <router-link class="link-el -children -risihoy" :to="'/'+$i18n.locale+'/'+$t('enlaces.quienessomos')">{{$t('header.quienessomos')}}</router-link>
            <router-link class="link-el -children -historia" :to="'/'+$i18n.locale+'/'+$t('enlaces.historia')">{{$t('header.historia')}}</router-link>
            <router-link class="link-el -children -codigo-conducta" :to="'/' + $i18n.locale + '/' + $t('enlaces.regulatory_compliance')">{{ $t('vistas.regulatory_compliance') }}</router-link>  
          </div>
          <div class="contenedor-texto-espiral" :show="showEspiral">
            <img :src="'/static/img/espiral' + ((!showEspiral) ? '.png' : '.gif')" class="espiral" alt="espiral">
            <p class="yummy">{{$t('header.conoceNuestraHistoria')}}</p>
          </div>
        </div>

        <div class="link-cont" @click="showMenu = false">
          <router-link class="link-el -nutririsi" :to="'/' + $i18n.locale + '/' + $t('enlaces.nutririsi')">{{ $t('header.nutririsi') }}</router-link>
        </div>
        <div class="link-cont" @click="showMenu = false">
          <router-link class="link-el -distribuidores" :to="'/' + $t('enlaces.distribuidores')">{{ $t('header.distribuidores') }}</router-link>
        </div>
        <div class="link-cont" @click="showMenu = false">
          <router-link class="link-el -noticias" :to="'/' + $i18n.locale + '/' + $t('enlaces.noticias')">{{ $t('header.noticias') }}</router-link>
        </div>
        <!-- <div class="link-cont" @click="showMenu = false">
          <a class="link-el -blog" href="https://risi.es/mios/blog/placerosofia" target="_blank">{{$t('header.blogPlacerosofia')}}</a>
        </div> -->
        
      </nav>

      <div class="rrss">
        <h3>{{$t('header.siguenos')}}</h3>
        <nav class="links row-center">
          <a href="https://www.instagram.com/risioriginal/?hl=es"><i class="fa fa-instagram"></i></a>
          <a href="https://www.tiktok.com/@risioriginal?lang=es" target="_blank"><img src="/static/img/icon-tiktok.svg"></a>
          <a href="https://x.com/RisiOriginal?lang=es" target="_blank"><img src="/static/img/icon-twitter-new.svg" height="17"></a>
        </nav>
      </div>

    </div>

  </section>

</template>

<script lang="js">
  import Languages from '@/components/parts/lang-selector'
  import Splitting from "splitting";

  import espiral from '@/components/parts/icons/espiral'

  import Slick from 'vue-slick';

  export default {
    name: 'app-header',
    data() {
      return {
        showMenu: false,
        select: '',
        showSobreRisi: false,
        showEspiral: false,
        withColors: [
          "home",
          'contacto',
          'noticia',
          'gusanitos',
          'snacks',
          'borges',
          'galletas',
          'natura',
          'pipas',
          'risketos',
          'mios',
          'matchBall',
          'triskys',
          'otrosProductos',
          'palomitas',
          'chocolate',
          'maria',
          'desayuno',
          'plus',
          'tradicionales',
          'infantiles',
          'premium',
          'caramelos',
          'adultas',
          'caramelosTradicionales',
          'azucares0',
          'promocion',
          'pressroom',
          'faqs',
          'frutossecos',
          'risi-hoy',
          'quienessomos',
          'aviso_legal',
          'politica_privacidad',
          'politica_cookies',
          'patatas',
          'carta-del-presidente',
          'risi-y-consumidores',
          'risi-y-sus-empleados',
          'principios-generales',
          'cumplimiento-etico',
          'risi-y-sociedad',
          'risi-y-sus-proveedores',
          'hoycontigo',
          'distribuidores',
          'selectas',
          'onduladas',
          'originales',
          'detodalavida',
          'plus',
          'fabs',
          'infantiles',
          'bsan',
          'regulatory_compliance',
          'jummy'
        ],
        slickOptions: {
          slidesToShow: 4,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                centerMode: true,
                slidesToShow: 1
              }
            }
          ]
        },
        slickOptionsPatatas: {
          slidesToShow: 4,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 520,
              settings: {
                centerMode: true,
                slidesToShow: 1
              }
            }
          ]
        },
      }
    },
    components: {
      'espiral': espiral,
      'lang-selector': Languages,
      Slick
    },
    mounted() {
      this.ownwaypoints();
      this.splitting();
      $("#header").addClass('launched');

      $(window).scroll(function (event) {
        if ($(window).scrollTop() > 200) {
          $(".menu .top").addClass('color');
        } else {
          $(".menu .top").removeClass('color');
        }
      });
    },
    methods: {
      ownwaypoints: function () {

        var waypoints = document.getElementsByClassName('animation');
        for (var i = 0; i < waypoints.length; i++) {
          new Waypoint({
            element: waypoints[i],
            offset: '90%',
            handler: function () {
              this.element.classList.add("launched")
            }
          });
        }


        var waypointsClass = document.getElementsByClassName('waypoints');
        for (var i = 0; i < waypointsClass.length; i++) {
          new Waypoint({
            element: waypointsClass[i],
            offset: '90%',
            handler: function () {
              var element = this.key.split('-')[1];
              var effect = this.element.attributes.getNamedItem('data');
              (effect != undefined) ? effect = effect.value : effect = "fadeInUp";
              this.element.classList.add("animated", effect)
            }
          });
        }


        var waypoints = document.getElementsByClassName('espiral-ani');
        for (var i = 0; i < waypoints.length; i++) {
          new Waypoint({
            element: waypoints[i],
            offset: '90%',
            handler: function () {
              var delay = this.element.attributes.getNamedItem('delay');
              (delay != undefined) ? delay = delay.value : delay = 0;
              setTimeout(e => {
                if (this.element.children[0].src.includes('.png')) {
                  if (!!this.element.children[0]) {
                    this.element.children[0].src = this.element.children[0].src.replace(".png", ".gif");
                    this.element.classList.add("launched");
                  }
                }
              }, Number(delay))
            }
          });
        }

      },
      splitting: function () {
        Splitting({
          target: "[data-splitting=chars]",
          by: "chars",
        });
      },
      setSubmenu: function (value) {
        this.select = value;
      }
    },
    computed: {
      color: function () {
        return (this.withColors.some(e => e == this.$route.name));
      },
      logosmall() {

      }
    },
    watch: {
      '$route': function () {
        setTimeout(() => {
          this.ownwaypoints();
          this.splitting();
          this.showMenu = false;
          this.showSobreRisi = false;
          this.showEspiral = false;
        }, 100);
      },
      'showMenu': function () {
        if (!this.showMenu) {
          this.showEspiral = false;
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

  nav.-galletas {
    justify-content: center;
  }

  .color.azucar {
    width: 100%;
    height: 100%;
  }

  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 10;
  }

  .supertop {
    display: none;
  }

  .menu .top {

    position: relative;
    padding: 0 50px;
    z-index: 20;

    &[with-color=true],
    &.color {
      background: $rouge;
    }

    .logo-header {
      position: absolute;
      left: 50px;
      top: -200px;
      transition: .4s;
      will-change: transform;
    }





    .hamburguer {
      overflow: hidden;
      width: 30px;
      display: inline-block;
      position: relative;
      margin-left: 15px;
      height: 60px;
      width: 60px;
      margin-right: 15px;

      &::after {
        position: absolute;
        left: 0;
        bottom: 50%;
        right: 0;
        top: 0;
        z-index: 1;
        content: '';
        transform: translateX(100%);
        background: $plum;
        transition: .2s;
        transition-timing-function: cubic-bezier(.57, .21, .69, 1.25);
      }

      &::before {
        position: absolute;
        left: 0;
        top: 50%;
        right: 0;
        bottom: 0;
        z-index: 1;
        content: '';
        transform: translateX(-100%);
        background: $plum;
        transition: .2s;
        transition-timing-function: cubic-bezier(.57, .21, .69, 1.25);

      }

      &[show=true]::before,
      &[show=true]::after {
        transform: translateX(0%);
        transition: .2s;
        transition-delay: 0s;
      }

      span {
        width: 30px;
        height: 2px;
        display: inline-block;
        background: white;
        position: absolute;
        z-index: 2;
        left: 50%;
        top: 50%;
        transform: translateY(-6px) translateX(-50%);
        transition: .2s;
        transition-timing-function: cubic-bezier(.57, .21, .69, 1.25);

        &.line-bottom {
          bottom: 50%;
          transform: translateY(6px) translateX(-50%);
          top: auto;
        }

        &.cross-left {
          right: 0;
          bottom: 0;
          left: auto;
          top: auto;
          z-index: 3;
          width: 20px;
          transform: translate(20px, 14px) rotate(45deg);
        }

        &.cross-right {
          right: 0;
          bottom: 0;
          left: auto;
          top: auto;
          z-index: 3;
          width: 20px;
          transform: translate(-50px, 16px) rotate(-45deg);
        }
      }

      &[show=true] .line-top {
        transform: translateY(-6px) translateX(-70px);
      }

      &[show=true] .line-bottom {
        transform: translateY(6px) translateX(70px);
      }

      &[show=true] .cross-right {
        transform: translate(-20px, -34px) rotate(-45deg);
      }

      &[show=true] .cross-left {
        transform: translate(-20px, -34px) rotate(45deg);
      }


    }

  }


  .menu-el.char-split.telefono-atc {
    display: flex; 
    align-items: center;
    img {
      height: 28px;
      margin-right: 3px;
    }
    figure {
      font-family: Futura LT CondensedExtraBold; 
      color: #fcc735; 
      font-size: 20px; 
      line-height: .8em;
    }
  }

  .header.launched {

    .logo-header {
      transform: translateY(200px);
      transition-timing-function: cubic-bezier(.57, .21, .69, 1.05);
    }

  }


  .desplegable {
    height: 100vh;
    width: 100%;
    position: absolute;
    left: 0;
    top: -100vh;
    transition: .4s;
    transition-delay: 0s;
    z-index: 15;
    background: rgba(104, 19, 29, 0.9);
    transition-timing-function: cubic-bezier(.57, .21, .69, 1.25);
    padding: 100px 0;
    overflow: hidden;

    &[show="true"] {
      transform: translateY(100vh);
      transition-delay: .1s;
    }

    .rrss {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 25px;

      h3 {
        font-family: 'Futura LT Condensed';
        margin-bottom: 10px;
        display: inline-block;
        width: 100%;
        font-size: 16px;
        text-transform: uppercase;
        color: white;
        transform: translateY(200px);
        transition: .5s;
        transition-delay: .2s;
      }

      a {
        color: white;
        width: 25px;
        height: 20px;
        transform: translateY(200px);
        transition: .5s;

        i {
          font-size: 18px;
        }
      }

      @for $i from 1 through 10 {
        a:nth-child(#{$i}) {
          transition-delay: #{$i / 10 + .6}s;
        }
      }

    }

    &[show="true"] .rrss {

      a,
      h3 {
        transform: translate(0);
      }
    }

    .link-cont {
      padding-bottom: 2vh;
      width: 100%;
      display: inline-block;
      position: relative;
      transition: 1s;

      &[show=true] {
        padding-bottom: calc(170px + 2vh);
      }

      &.-sobrerisi {
        width: 100%;
        max-width: 340px;
      }

      .link-el {
        font-size: 36px;
        color: #fff;
        font-family: 'Futura LT CondensedBold';
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        justify-content: center;
        -webkit-justify-content: center;
        -ms-align-items: center;
        align-items: center;
        width: 100%;
        opacity: 0;
        transition: .5s;
        transform: translateX(-100vw);
        transition-delay: .5s;
        letter-spacing: 1px;



        &.-children {
          text-transform: uppercase;
          color: rgba(255, 255, 255, .6);
          font-size: 24px;
          margin-bottom: 5px;
          letter-spacing: 1px;
        }
      }

      @media screen and (min-width: 1024px) {
        .link-el {
          padding-right: 40px;

          &::before {
            content: '';
            width: 40px;
            height: 40px;
            overflow: hidden;
            display: inline-block;
            margin-right: 10px;
            transition: .5s;
          }

          &.-inicio::before {
            background: url(/static/img/logo.png) center -50px/35px no-repeat;
          }

          &.-inicio:hover::before {
            background-position: top center;
          }


          &.-sobrerisi::before {
            background: url(/static/img/Palomitachoco1.png) center 50px/35px no-repeat;
          }

          &.-historia::before {
            background: url(/static/img/furgoneta-risi.png) -50px center/35px no-repeat;
          }

          &.-risihoy::before {
            background: url(/static/img/bandera-risi.png) center 50px/35px no-repeat;
          }


          &.-codigo-conducta::before {
            background: url(/static/img/carpeta-conducta.png) center 50px/35px no-repeat;
          }

          &.-hoy-siempre::before {
            background: url(/static/img/logo-plano.png) center 50px/28px no-repeat;
          }

          &.-blog::before {
            background: url(/static/img/mio.png) center 50px/30px no-repeat;
          }

          &.-risihoy:hover::before,
          &.-promociones:hover::before {
            background-position: center bottom;
          }

          &.-contacto::before {
            background: url(/static/img/telefono.png) center 50px/35px no-repeat;
          }

          &.-contacto:hover::before,
          &.-hoy-siempre:hover::before {
            background-position: left center;
          }

          &.-promociones::before {
            background: url(/static/img/personajes-risketos.png) center 50px/35px no-repeat;
          }

          &.-noticias::before {
            background: url(/static/img/megafono.png) center 50px/35px no-repeat;
          }

          &.-nutririsi::before {
            background: url(/static/img/montana-gusanitos.png) center 50px/40px no-repeat;
          }

          &.-distribuidores::before {
            background: url(/static/img/polaroid.png) center 50px/40px no-repeat;
          }


          &:hover::before {
            background-position: center;
          }
        }
      }

      &:nth-child(2n) .link-el {
        transform: translateX(100vh);
      }

      .childrens {
        margin-top: 1vh;
        display: inline-block;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 1vh;
        height: 171px;
        opacity: 0;
        pointer-events: none;
        transition: 1s;
      }

      .childrens[show=true] {
        opacity: 1;
        pointer-events: visible;
      }



    }

    &[show="true"] .link-el,
    &[show="true"] .link-cont:nth-child(2n) .link-el {
      transform: translateX(0);
      opacity: 1;
    }

    @for $i from 1 through 10 {
      &[show="true"] .link-cont:nth-child(#{$i}) .link-el {
        transition-delay: #{$i / 10 + .7}s;
      }
    }

  }

  .bottom {
    width: 100%;
    background: #68131d;
    position: fixed;
    left: 0;
    top: 60px;
    z-index: 4;

    .menu-el {
      width: auto;
      padding: 5px 20px;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      justify-content: center;
      -webkit-justify-content: center;
      -ms-align-items: center;
      align-items: center;
      -webkit-align-items: center;
      position: relative;
      max-width: 140px;
      max-height: 80px;

      &.-otros {
        height: 73.64px;
        max-width: 170px;

        h2 {
          font-size: 20px;
          text-transform: uppercase;
          color: #fff;
          font-family: 'Futura LT CondensedExtraBold';
          line-height: 1em;
          transform: rotate(-9deg);

          span {
            font-family: 'Futura LT CondensedExtraBold';
            font-size: 14px;
            line-height: 1em;
          }

          strong {
            font-size: 30px;
            font-family: 'Futura LT CondensedExtraBold';
            width: 100%;
            line-height: 1.1em;
          }
        }
      }


      &.-caramelo {
        width: 200px;
        max-width: 200px;

        h2 {
          font-size: 16px;
          line-height: 1.1em;
        }

        &.-azucares {
          h2 {
            margin-top: -10px;
          }
        }
      }

      img {
        max-width: 100%;
        max-height: 100%;
        transition: .5s;
      }
      &.-galleta{
        img{
          padding-top: 10px;
        }
      }
      .color {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        transition: 0s;
        transition-timing-function: ease-in-out;
        opacity: 0;
      }


      .sin-gluten {
        max-width: 73px;
      }

      .bsan-plus {
        max-width: 82px;
      }

      &.-big {
        .color {
          max-width: 100%;
        }
      }


      &.router-link-exact-active,
      &.router-link-active {
        background: white;

        .color {
          opacity: 1;
        }

        h2 {
          color: #68131d;
        }

        &.-caramelo {
          h2 {
            color: #00796b;
          }
        }

        &.-azucares {
          h2 {
            color: #ec6087;
          }
        }
      }
    }

    .-cumplimiento {

      .menu-el.-large {
        max-width: 230px;
      }

      .menu-el.router-link-exact-active,
      &.menu-el.router-link-active {
        background: white;
      }

      .menu-el.-otros h2 {
        transform: none;
        font-size: 18px;
        line-height: 1.2em;
      }
    }



  }

  .contenedor-texto-espiral {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 3;
    transform: rotate(-15deg) translateX(100%);
    padding-top: 130px;

    .espiral {
      transform: rotateY(190deg) rotate(15deg);
      position: absolute;
      left: 0;
      top: 0px;
      max-width: 120px;
      opacity: 0;
      transition: .1s;
      transition-delay: .2s;
    }

    p {
      color: white;
      font-size: 36px;
      text-align: center;
      max-width: 300px;
      line-height: 32px;
      transform: rotate(-10deg);
      opacity: 0;
      transition: 1s;
      transition-delay: 1s;
    }

    &[show=true] {
      .espiral {
        opacity: 1;
      }

      p {
        opacity: 1;
      }
    }
  }

  .-snacks .slide {
    width: 100%;
    outline: none;
    min-width: 150px;
  }

  .-snacks .slick-slider {
    max-width: 800px;
    width: 100%;
    outline: none;
  }


  .bottom .-snacks .menu-el {
    max-width: 100%;
    text-align: center;
    max-height: 100%;
    min-height: 75px;
  }

  .bottom .-snacks .menu-el img {
    max-height: 63.64px;
  }



  @media screen and (min-width: 1024px) {
    .bottom .menu-el:hover {
      background: white;

      .color {
        opacity: 1;
      }

      h2 {
        color: #68131d;
      }

      &.-caramelo h2 {
        color: #00796b;
      }

      &.-azucares {
        h2 {
          color: #ec6087;
        }
      }
    }
  }


  @media screen and (max-width: 1530px) {
    nav.-cumplimiento {
      justify-content: flex-end;
    }
  }

  @media screen and (max-width: 1300px) {
    .bottom nav {
      padding-left: 165px;
    }

    .bottom .-cumplimiento .menu-el.-otros h2 {
      font-size: 14px;
    }

    .bottom .-cumplimiento .menu-el {
      max-width: 120px;
      padding: 5px 10px;
    }

    .bottom .-cumplimiento .menu-el.-large {
      max-width: 170px;
    }
  }

  @media screen and (max-width: 1260px) {
    .bottom .menu-el.-galleta[data-v-450de70e] {
      max-width: 130px;
      padding: 5px 24px;

      max-height: 60px;
    }

    .bottom {

      &[scroll=true] {
        overflow: scroll;
      }


      nav {
        padding-left: 0;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;
        padding-right: 30px;

        &.-cumplimiento {
          min-width: 1140px;
          padding-right: 0;
        }
      }

      .menu-el {
        max-width: 130px;
        padding: 5px 20px;
        background: #68131d;
        max-height: 60px;

        &.-otros {
          height: 60px;
        }

        .color {
          max-width: 80px;
        }

        &.-galleta {
          max-width: 164px;

          img {
            max-width: 85px;
            max-height: 40px;
          }

          img.azucar {
            max-width: 55px;
            max-height: 40px;
          }

          h2 {
            font-size: 18px;
          }
        }
      }

      nav.-borges {
        .menu-el {
          padding: 10px 10px;
          width: 33.3333333%;
        }
      }

    }

    .contenedor-texto-espiral {
      display: none;
    }

    .bottom nav.-caramelos {
      justify-content: center;
      -webkit-justify-content: center;
    }

  }

  @media screen and (max-width: 1180px) {
    .bottom nav.-cumplimiento {
      justify-content: flex-start;
      padding-left: 180px;
      background: $plum;
    }
  }

  @media screen and (max-width: 890px) {

    .menu .top .logo-header[small=true] img {
      max-height: 60px;
      width: auto;
    }

    .bottom {
      overflow: scroll;
      left: auto;
      right: 0;
      background: transparent;

      &::before {
        position: absolute;
        left: 0;
        top: 0;
        background: #68131d;
        display: inline-block;
        content: '';
        width: 100%;
        height: 60px;
      }

      .-snacks .menu-el img {
        max-height: 56px;
      }

      .menu-el.router-link-exact-active,
      &.menu-el.router-link-active {
        background: white;
      }


      &.menu-el.router-link-active .color {
        opacity: 0;
      }

      .menu-el,
      .-snacks .menu-el {
        max-height: 60px;
      }

      nav.-galletas {
        min-width: 661px;
        height: 60px;
        padding-right: 0;
        display: flex;
        justify-content: flex-start !important;

        .-otros:last-of-type {
          margin-right: 0;
        }
      }

      nav.-caramelos {
        min-width: 400px;
        padding-right: 0;

        .-otros:last-of-type {
          margin-right: 0;
        }
      }
    }


    .desplegable .rrss a {
      width: 50px;
      height: 50px;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      justify-content: center;
      -webkit-justify-content: center;
      -ms-align-items: center;
      align-items: center;
      -webkit-align-items: center;
      margin-right: 8px;

      &:last-of-type {
        margin-rigth: 8px;
      }

      i {
        font-size: 30px;
      }
    }

    .menu .top {
      padding-left: 20px;
      padding-right: 20px;
    }

    .menu .top .logo-header {
      left: 20px;
    }
    .bottom .menu-el.-galleta img{
      padding-top: 0;
    }
  }

  @media screen and (max-width: 767px) {
    .menu .top {
      padding: 0px;
      justify-content: center;


      .logo-header {
        left: 0;
        top: -245px;
      }

    }

    .menu .bottom {
      top: 103px;
      overflow: hidden;
    }


    .bottom nav.-galletas {
      min-width: 637px;
    }

    .desplegable {
      padding-top: 50px;
    }

    .menu .top .telefono-atc {
      display: none;
    }

    .supertop {
      display: flex;
      background: $plum;
      width: 100%;
      justify-content: end;
      padding: 8px 20px;
      .telefono-atc figure {
        color: white !important;
      }
    }


  }

  @media screen and (max-width: 500px) {
    .menu .top {
      padding-right: 0;

      .logo-header {
        left: 10px;

        img {
          max-width: 50px;
        }
      }

      .hamburguer {
        margin-left: 0;
        width: 60px;
      }


    }

    .desplegable .link-cont .link-el {
      font-size: 24px;

      &.-children {
        font-size: 16px;
      }
    }

    .desplegable .link-cont .childrens {
      height: 80px;
      top: 30px;
    }

    .desplegable .link-cont[show=true] {
      padding-bottom: 80px;
    }

    .menu-productos .menu-el {
      font-size: 12px;
    }


    .menu .top .hamburguer {
      width: 35px;
    }

    .bottom {
      nav.-caramelos {
        min-width: 320px;

        .menu-el {
          width: 160px;

          h2 {
            font-size: 12px;

            strong {
              font-size: 20px;
            }
          }
        }
      }
    }


    .menu-productos .menu-el {
      padding: 20px 5px;
    }

    .bottom nav.-cumplimiento {
      padding-left: 0px;
      min-width: 942px;
    }
  }

  @media screen and (max-width: 365px) {

    .menu-productos .menu-el {
      font-size: 12px;
      padding: 20px 3px;
    }

    .menu .top .hamburguer {
      height: 40px;
    }

    .bottom {
      top: 40px;
    }

  }

  @media screen and (max-width: 340px) {
    .menu-productos .menu-el {
      font-size: 11px;
      padding: 10px 3px;
    }

    .menu .top .logo-header img {
      max-width: 70px;
    }

    .bottom {
      padding-left: 0px;
    }

    .padding-menu {
      padding-top: 41px;
    }

    .menu .top .logo-header[small=true] img {
      max-height: 45px;
    }

    .menu .bottom {
      top: 82px;
    }

  }

  @media screen and (max-height: 769px) {
    [route="historia"] .menu .top .logo-header img {
      max-height: 80px;
      width: auto;
    }

    .desplegable .link-cont .link-el {
      font-size: 28px;
    }
  }

  @media screen and (max-height: 700px) {

    .desplegable .link-cont {
      padding-bottom: 5px;
    }

    .desplegable .link-cont .link-el {
      font-size: 24px;
    }

    .desplegable .link-cont .link-el.-children {
      font-size: 14px;
    }

  }

  @media screen and (max-height: 600px) {
    .menu .top .logo-header img {
      max-height: 80px;
      width: auto;
    }

    .desplegable {
      padding-top: 70px;
    }


    .desplegable .link-cont .link-el {
      font-size: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue